/**
 * SPA entry point.
 *
 * Wires the three providers every screen relies on: TanStack Query for server
 * state (no server data ever lives in `useState`), the browser router, and the
 * design tokens stylesheet.
 */

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App';
import './styles/tokens.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Financial figures must not look fresher than they are: refetch when the
      // operator returns to the tab, and treat anything older than 30s as stale.
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      retry: 1,
    },
  },
});

const container = document.getElementById('root');

if (container === null) {
  throw new Error('Torvanis Money could not start: the #root element is missing from index.html.');
}

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
